__turbopack_context__.v({
  "blok-big-title": "YarnWidget-module__KbqBuq__blok-big-title",
  "blok-subtitle": "YarnWidget-module__KbqBuq__blok-subtitle",
  "blok-title": "YarnWidget-module__KbqBuq__blok-title",
  "circleImage": "YarnWidget-module__KbqBuq__circleImage",
  "circles": "YarnWidget-module__KbqBuq__circles",
  "imageWrapper": "YarnWidget-module__KbqBuq__imageWrapper",
  "spread": "YarnWidget-module__KbqBuq__spread",
});
